import { render, staticRenderFns } from "./smallTicket.vue?vue&type=template&id=23dad944&scoped=true&"
import script from "./smallTicket.vue?vue&type=script&lang=js&"
export * from "./smallTicket.vue?vue&type=script&lang=js&"
import style0 from "./smallTicket.vue?vue&type=style&index=0&id=23dad944&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dad944",
  null
  
)

export default component.exports